import {FETCH_TAXES} from "../../constant/ActionType";

export default function TaxesReducer(state = {
    taxes:[],
    statusCode: null,
}, action) {
    switch (action.type) {    
        case FETCH_TAXES:
			return { ...state,
				taxes: action.data ,
                statusCode:action.status
            };

        default:
    }
    return state;
}
